import gql from 'graphql-tag';

export const getVotingAnswers = gql`
  query ($votingQuestion: Int) {
    getVotingAnswers(votingQuestion: $votingQuestion) {
      votingAnswerId
      choices
      votingToken {
        referralId
        views
        votingDate
      }
    }
  }
`
